import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry
*/
import React from 'react';
import Block from 'wfui-digital-core/es/Block';
import SvgIcon from 'wfui-digital-core/es/SvgIcon';
import accessibleIcon from 'wfui-digital-core/es/accessibleIcon';
import useBrand from 'wfui-digital-core/es/useBrand';
import useSettings from '../../hooks/use-settings';
import { getIconClasses } from 'wfui-digital-core/es/lib';
import styles from './CustomerAvatarIcon.less';

var MassMarketIcon = function MassMarketIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 30 30"
  }), /*#__PURE__*/React.createElement("g", {
    "data-testid": "mm"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "13.866",
    cy: "13.866",
    r: "13.866"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: "13.866",
    cy: "13.866",
    r: "11.786"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.121 1.154)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    cx: "13.866",
    cy: "13.866",
    r: "14.366"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D71E28",
    mask: "url(#b)",
    cx: "13.866",
    cy: "13.866",
    r: "13.866"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D71E28",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.257 8.396c0 2.464-1.936 4.46-4.328 4.46-2.391 0-4.329-1.996-4.329-4.46 0-2.462 1.938-4.46 4.329-4.46 2.392 0 4.328 1.998 4.328 4.46zM22.46 24.32c.224 2.8-1.823 5.09-4.55 5.09H9.816c-2.726 0-4.773-2.29-4.549-5.09l.59-3.523c.224-2.8 2.637-5.09 5.364-5.09h5.286c2.726 0 5.14 2.29 5.365 5.09l.589 3.523z",
    stroke: "#FFF",
    strokeWidth: "2",
    mask: "url(#d)"
  }))));
};

var ThePrivateBankIconBIM = function ThePrivateBankIconBIM(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 40 40"
  }), /*#__PURE__*/React.createElement("g", {
    "data-testid": "tpb-bim"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-21.4%",
    y: "-21.4%",
    width: "142.9%",
    height: "142.9%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: "1",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "1",
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    fill: "#946E3A",
    stroke: "#FFF",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "17.5",
    r: "18"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.442 31.074a15.469 15.469 0 01-1.784-1.742l.105-.61c.338-4.08 3.944-7.398 8.054-7.398h6.941c4.11 0 7.716 3.317 8.043 7.31l.121.703a15.469 15.469 0 01-1.779 1.737l-.374-2.177c-.252-3.028-2.977-5.527-6.018-5.527h-6.918c-3.041 0-5.765 2.499-6.027 5.613l-.364 2.091zM26.478 13.65c0 3.672-2.983 6.65-6.673 6.65-3.688 0-6.672-2.979-6.672-6.65 0-3.669 2.985-6.65 6.672-6.65 3.689 0 6.673 2.98 6.673 6.65zm-2.053 0c0-2.545-2.07-4.604-4.62-4.604-2.548 0-4.619 2.06-4.619 4.604a4.611 4.611 0 004.62 4.605 4.61 4.61 0 004.62-4.605z",
    fill: "#FFF"
  }))));
};

var ThePrivateBankIcon = function ThePrivateBankIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 50 50"
  }), /*#__PURE__*/React.createElement("g", {
    "data-testid": "tpb"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-20.0%",
    y: "-15.0%",
    width: "140.0%",
    height: "140.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: "0",
    dy: "2",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2",
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-4",
    cx: "20",
    cy: "20",
    r: "17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbols-|-fat-nav",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customer_avatar/tpb",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn-ind-customer-avatar-tpb",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MV_1012_17094_B-Copy",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#8F8F8F",
    strokeWidth: "1",
    cx: "20",
    cy: "20",
    r: "20.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 4.750000)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(12.000000, 5.000000)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,25 C1,25 1,21 3,19 C5,17 6,16 9,16 C11,16 14.3333333,16 19,16 C21.6666667,17.3333333 23.3333333,19 24,21 C24.6666667,23 25,25.6666667 25,29 L25,33 L2,33 L1,31 C1,27 1,25 1,25 Z",
    id: "Path-2",
    stroke: "none",
    fillOpacity: "0.15",
    fill: "#876632",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3962434,28.0807208 L24.5469871,23.0000133 C24.2226948,18.961793 20.7401512,15.6581118 16.8080013,15.6581118 L9.18416896,15.6581118 C5.25117237,15.6581118 1.7694755,18.961793 1.44602992,23.0000133 L0.595926893,28.0807208 C0.272481318,32.1189412 3.22498059,35.42175 7.15713046,35.42175 L18.8350398,35.42175 C22.7671897,35.42175 25.719689,32.1189412 25.3962434,28.0807208 Z",
    id: "Stroke-1",
    stroke: "#876632",
    strokeWidth: "2",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "none",
    fillOpacity: "0.15",
    fill: "#876632",
    fillRule: "evenodd",
    cx: "13",
    cy: "7",
    r: "6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.334433,6.55253128 C19.334433,10.1065839 16.5411164,12.9862912 13.090748,12.9862912 C9.64207306,12.9862912 6.84790972,10.1065839 6.84790972,6.55253128 C6.84790972,3.00196816 9.64207306,0.119643703 13.090748,0.119643703 C16.5411164,0.119643703 19.334433,3.00196816 19.334433,6.55253128 Z",
    id: "Stroke-3",
    stroke: "#876632",
    strokeWidth: "2",
    fill: "none"
  }))))))));
};

var CustomerAvatarIcon = function CustomerAvatarIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '50px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '50px' : _ref$height,
      className = _ref.className,
      keepProps = _objectWithoutProperties(_ref, ["width", "height", "className"]);

  var brand = useBrand();

  var _useSettings = useSettings(),
      useTPBBimUpdates = _useSettings.useTPBBimUpdates;

  var classNames = getIconClasses({
    styles: styles,
    classes: ['customerAvatar'],
    className: className
  });

  if ('tpb' === brand) {
    return useTPBBimUpdates ? /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(ThePrivateBankIconBIM, _extends({
      width: width,
      height: height,
      className: classNames
    }, keepProps))) : /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(ThePrivateBankIcon, _extends({
      width: width,
      height: height,
      className: classNames
    }, keepProps)));
  } else {
    return /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(MassMarketIcon, _extends({
      width: width,
      height: height,
      className: classNames
    }, keepProps)));
  }
};

export default accessibleIcon(CustomerAvatarIcon);